import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log to console for debugging
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
    
    // Ignore ApexCharts DOM access errors - they're often harmless
    if (error?.message?.includes('screenCTM') || error?.message?.includes('getBoundingClientRect')) {
      console.warn('[ErrorBoundary] Ignoring ApexCharts DOM access error');
      // Reset state to not show error for these specific errors
      setTimeout(() => {
        this.setState({ hasError: false, error: null });
      }, 0);
    }
  }

  render() {
    if (this.state.hasError && !this.state.error?.message?.includes('screenCTM') && !this.state.error?.message?.includes('getBoundingClientRect')) {
      return (
        <div
          style={{
            padding: '20px',
            background: '#fee2e2',
            border: '1px solid #fca5a5',
            borderRadius: '8px',
            color: '#991b1b',
            fontSize: '14px',
          }}
        >
          <strong>Error Loading Chart:</strong>
          <p>{this.state.error?.message}</p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              padding: '8px 16px',
              background: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '8px',
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
